(function () {
  function $(root, sel) {
    return root.querySelector(sel);
  }

  function setStatus(statusEl, msg, type) {
    if (!statusEl) return;
    statusEl.innerHTML = "";
    statusEl.dataset.type = type || "";
    if (type === "loading") {
      var spinner = document.createElement("span");
      spinner.className = "ae__spinner";
      statusEl.appendChild(spinner);
    }
    if (msg) {
      var text = document.createElement("span");
      text.textContent = msg;
      statusEl.appendChild(text);
    }
  }

  async function fetchJSON(url, opts) {
    const res = await fetch(url, opts);
    const contentType = res.headers.get("content-type") || "";
    const isJSON = contentType.includes("application/json");
    const body = isJSON ? await res.json() : await res.text();

    if (!res.ok) {
      const msg =
        typeof body === "string"
          ? body
          : (body && body.detail) || JSON.stringify(body);
      throw new Error(`HTTP ${res.status}: ${msg}`);
    }
    return body;
  }

  function renderSources(sourcesEl, sources) {
    if (!sourcesEl) return;
    sourcesEl.innerHTML = "";

    if (!sources || sources.length === 0) {
      return;
    }

    const frag = document.createDocumentFragment();
    const fallback =
      "https://support.reekon.tools/hc/theming_assets/01K7F7SD6GPQK6PTTYZKF8GBDY";

    sources.forEach((s) => {
      const card = document.createElement("a");
      card.className = "ae__sourceCard";
      card.href = s.external_url || s.link_url || "#";
      if (card.href !== "#") {
        card.target = "_blank";
        card.rel = "noopener noreferrer";
      }

      const img = document.createElement("img");
      img.className = "ae__sourceThumb";
      img.alt = s.title || "Source thumbnail";
      img.loading = "lazy";
      img.decoding = "async";
      img.referrerPolicy = "no-referrer";
      img.src = s.thumbnail_url || s.image_url || fallback;

      const title = document.createElement("div");
      title.className = "ae__sourceTitle";
      title.textContent = s.title || s.external_url || "Untitled";

      const meta = document.createElement("div");
      meta.className = "ae__sourceMeta";
      meta.textContent = [s.source_kind, s.kind].filter(Boolean).join(" · ");

      card.appendChild(img);
      card.appendChild(title);
      card.appendChild(meta);

      frag.appendChild(card);
    });

    sourcesEl.appendChild(frag);
  }

  function buildDetailUrl(base, slug) {
    if (!base || !slug) return "#";
    if (base.includes("{slug}")) {
      return base.replace("{slug}", slug);
    }
    if (base.includes("{public_id}")) {
      return base.replace("{public_id}", slug);
    }
    return base.replace(/\/?$/, "/") + slug;
  }

  function renderCards(gridEl, queries, detailBase) {
    if (!gridEl) return;
    gridEl.innerHTML = "";

    if (!queries || queries.length === 0) {
      const empty = document.createElement("div");
      empty.className = "ae__status";
      empty.textContent = "No recent queries yet.";
      gridEl.appendChild(empty);
      return;
    }

    const fallback =
      "https://support.reekon.tools/hc/theming_assets/01K7F7SD6GPQK6PTTYZKF8GBDY";
    const frag = document.createDocumentFragment();

    queries.forEach((q) => {
      const link = document.createElement("a");
      link.className = "ae__card";
      link.href = buildDetailUrl(detailBase, q.slug || q.public_id);

      const img = document.createElement("img");
      img.className = "ae__thumb";
      img.alt = q.title || q.query || "Recent query";
      img.loading = "lazy";
      img.decoding = "async";
      img.referrerPolicy = "no-referrer";
      img.src = q.thumbnail_url || fallback;

      const title = document.createElement("div");
      title.className = "ae__cardTitle";
      title.textContent = q.title || q.query || "Untitled query";

      link.appendChild(title);
      link.appendChild(img);

      frag.appendChild(link);
    });

    gridEl.appendChild(frag);
  }

  async function initSection(sectionEl) {
    const endpoint = sectionEl.getAttribute("data-recent-endpoint");
    const detailBase = sectionEl.getAttribute("data-detail-base") || "";
    const searchEndpoint = sectionEl.getAttribute("data-endpoint");
    const statusEl = $(sectionEl, "[data-ae-status]");
    const recentStatusEl = $(sectionEl, "[data-ae-recent-status]");
    const gridEl = $(sectionEl, "[data-ae-grid]");
    const formEl = $(sectionEl, "[data-ae-form]");
    const inputEl = $(sectionEl, "[data-ae-input]");
    const submitEl = $(sectionEl, "[data-ae-submit]");
    const sourcesEl = $(sectionEl, "[data-ae-sources]");

    if (!endpoint) {
      setStatus(recentStatusEl, "Missing recent queries endpoint.", "error");
    } else {
      try {
        setStatus(recentStatusEl, "Loading recent queries...", "loading");
        const url = new URL(endpoint, window.location.origin);
        url.searchParams.set("limit", "50");

        const data = await fetchJSON(url.toString(), { method: "GET" });
        renderCards(gridEl, data.queries || [], detailBase);
        setStatus(recentStatusEl, "", "");
      } catch (err) {
        console.error(err);
        setStatus(
          recentStatusEl,
          err.message || "Failed to load recent queries.",
          "error"
        );
      }
    }

    if (!searchEndpoint) {
      setStatus(statusEl, "Missing search endpoint.", "error");
      return;
    }

    async function runQuery() {
      const query = (inputEl.value || "").trim();

      if (!query) return;

      submitEl.disabled = true;
      inputEl.disabled = true;

      setStatus(statusEl, "Thinking...", "loading");
      renderSources(sourcesEl, []);

      try {
        const payload = { query };

        const data = await fetchJSON(searchEndpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (data.blocked) {
          setStatus(statusEl, data.message || "This query is not supported.", "error");
          return;
        }

        const slug = data.slug || data.public_id;
        if (!slug) {
          throw new Error("Missing slug in response.");
        }

        setStatus(statusEl, "Redirecting...", "success");
        var detailUrl = `https://reekon.tools/apps/mountn-ai/${encodeURIComponent(slug)}`;
        if (data.feedback_token) {
          detailUrl += `#ft=${encodeURIComponent(data.feedback_token)}`;
        }
        window.location.assign(detailUrl);
        return;
      } catch (err) {
        console.error(err);
        setStatus(statusEl, err.message || "Request failed.", "error");
        renderSources(sourcesEl, []);
      } finally {
        submitEl.disabled = false;
        inputEl.disabled = false;
      }
    }

    submitEl.addEventListener("click", runQuery);

    inputEl.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        runQuery();
      }
    });

    formEl.addEventListener("submit", (e) => {
      e.preventDefault();
      runQuery();
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-ae]").forEach((el) => initSection(el));
  });
})();
